import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Avatar = ({ initials }) => (
  <div className="h-32 w-32 rounded-full bg-deepgreen text-gold flex items-center justify-center text-3xl font-serif font-bold mb-6 shadow-lg border-4 border-white">
    {initials}
  </div>
);

function TeamPage() {
  return (
    <div className="bg-gray-50 text-deepgreen min-h-screen font-sans">
      <Navbar />

      {/* Header Section */}
      <section className="bg-deepgreen text-white py-24 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-extrabold mb-6" data-aos="fade-up">
            Our Team
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="100">
            ELVIS NANDA, WEKE & COMPANY ADVOCATES is led by dedicated professionals who uphold the firm’s mission: to restore public confidence in the legal profession through professionalism, humility, and integrity.
          </p>
        </div>
      </section>

      <section className="px-6 py-20 max-w-6xl mx-auto -mt-16 relative z-10">
        {/* Partners */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold mb-2" data-aos="fade-up">Partners</h2>
          <div className="w-16 h-1 bg-gold mx-auto"></div>
        </div>
        
        <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 text-left mb-20">
          <div className="bg-white p-8 rounded-xl shadow-xl flex flex-col items-center text-center hover:-translate-y-2 transition duration-300" data-aos="fade-up">
            <img
              src="/team/odira.jpeg"
              alt="Odira Elvis W. Nanda"
              className="w-32 h-32 object-cover object-top rounded-full mb-6 shadow-lg border-4 border-white"
            />
            <h3 className="text-2xl font-serif font-bold mb-2">Odira Elvis W. Nanda</h3>
            <p className="text-gold font-bold uppercase tracking-wider text-sm mb-4">Managing Partner</p>
            <p className="text-gray-600 leading-relaxed">
              With 8 years of legal practice, Mr. Nanda brings vast experience in litigation and labour law. He previously headed the Litigation Department at Gordon Ogola, Kipkoech & Co. Advocates.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-xl flex flex-col items-center text-center hover:-translate-y-2 transition duration-300" data-aos="fade-up" data-aos-delay="100">
            <img
              src="/team/weke.jpeg"
              alt="Mary Stella Weke"
              className="w-32 h-32 object-cover object-top rounded-full mb-6 shadow-lg border-4 border-white"
            />
            <h3 className="text-2xl font-serif font-bold mb-2">Mary Stella Weke</h3>
            <p className="text-gold font-bold uppercase tracking-wider text-sm mb-4">Senior Partner</p>
            <p className="text-gray-600 leading-relaxed">
              Ms. Weke has 4 years of legal experience, previously serving in the conveyancing department of Kittony Maina Karanja Advocates, handling major corporate real estate portfolios.
            </p>
          </div>
        </div>

        {/* Associates & Pupil */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold mb-2" data-aos="fade-up">Associates & Pupil</h2>
          <div className="w-16 h-1 bg-gold mx-auto"></div>
        </div>

        <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 text-left mb-20">
          <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center hover:shadow-lg transition" data-aos="fade-up">
            <img
              src="/team/kamili.jpeg"
              alt="Andrew Kamili"
              className="w-32 h-32 object-cover rounded-full mb-6 shadow-md border-4 border-gray-100"
              />
            <h4 className="text-xl font-serif font-bold mb-1">Andrew Kamili</h4>
            <p className="text-gold text-sm font-bold uppercase mb-3">Associate Advocate</p>
            <p className="text-gray-600 text-sm">
              A graduate of CUEA and admitted to the Bar in 2024, Andrew is involved in general practice and legal research within the firm.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center hover:shadow-lg transition" data-aos="fade-up" data-aos-delay="100">
            <img
              src="/team/stacy-cherop.jpg"
              alt="Stacy Cherop"
              className="w-32 h-32 object-cover rounded-full mb-6 shadow-md border-4 border-gray-100"
            />
            <h4 className="text-xl font-serif font-bold mb-1">Stacy Cherop</h4>
            <p className="text-gold text-sm font-bold uppercase mb-3">Associate Advocate</p>
            <p className="text-gray-600 text-sm">
              Also a graduate of CUEA, admitted in 2024. Stacy contributes to litigation, client consultation, and property documentation review.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center hover:shadow-lg transition" data-aos="fade-up" data-aos-delay="200">
           <Avatar initials="LK" />
            <h4 className="text-xl font-serif font-bold mb-1">Linus Kamket</h4>
            <p className="text-gold text-sm font-bold uppercase mb-3">Associate Advocate</p>
            <p className="text-gray-600 text-sm">
              A Moi University alumnus, admitted in 2022. Linus assists in dispute resolution, land matters, and contract negotiation.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center text-center hover:shadow-lg transition" data-aos="fade-up" data-aos-delay="300">
            <img
              src="/team/mike-okoth.jpg"
              alt="Mike Okoth Odhiambo"
              className="w-32 h-32 object-cover rounded-full mb-6 shadow-md border-4 border-gray-100"
            />
            <h4 className="text-xl font-serif font-bold mb-1">Mike Okoth Odhiambo</h4>
            <p className="text-gold text-sm font-bold uppercase mb-3">Pupil</p>
            <p className="text-gray-600 text-sm">
              Mike is undergoing his pupilage at the firm, supporting litigation, research, and client service across departments.
            </p>
          </div>
        </div>

        {/* Support Team */}
        <div className="bg-white p-10 rounded-xl shadow-lg border-l-8 border-deepgreen" data-aos="fade-up">
          <h2 className="text-2xl font-serif font-bold mb-6 text-deepgreen">Support Team</h2>
          <div className="grid sm:grid-cols-2 gap-6 text-gray-700">
            <div className="flex items-center gap-3">
              <span className="w-2 h-2 bg-gold rounded-full"></span>
              <span><strong>Secretaries:</strong> Caroline Saranga</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="w-2 h-2 bg-gold rounded-full"></span>
              <span><strong>Receptionist:</strong> Priska Abongo</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="w-2 h-2 bg-gold rounded-full"></span>
              <span><strong>Accounts Clerk:</strong> Paul Ndegwa</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="w-2 h-2 bg-gold rounded-full"></span>
              <span><strong>Driver:</strong> Stephwin Maundu Muange</span>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default TeamPage;
